import { render, staticRenderFns } from "./TableHeadDataInspection.vue?vue&type=template&id=151f438f"
import script from "./TableHeadDataInspection.vue?vue&type=script&lang=ts"
export * from "./TableHeadDataInspection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports